import { type FC } from "react";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { AnalyticsMetrics } from "@/partner/shared/components/AnalyticsMetrics";
import { formatNumber } from "@/shared/utils/formatNumber";
import { formatCurrency } from "@/partner/features/products";
import { useAnalyticsSalesMetricsQuery } from "@/partner/entities/analytics";

export const AnalyticsSalesMetrics: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsSalesMetricsQuery({
    fetchPolicy: "no-cache",
    variables: { filter: filter as never },
  });

  const metrics = [
    {
      icon: ShoppingCartIcon,
      label: t("analytics.sales.metricsSales"),
      value: formatNumber(data?.analyticsSales.sales ?? 0),
    },
    {
      icon: PeopleIcon,
      label: t("analytics.sales.metricsPurchasers"),
      value: formatNumber(data?.analyticsSales.purchasers ?? 0),
    },
    {
      icon: AttachMoneyIcon,
      label: t("analytics.sales.metricsRevenue"),
      value: formatCurrency(
        data?.analyticsSales.revenue ?? 0,
        data?.analyticsSales.currency ?? "USD"
      ),
    },
  ];

  return (
    <AnalyticsMetrics
      metrics={metrics}
      loading={loading}
      error={error}
      xs={12}
      md={4}
    />
  );
};
